var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuscleBone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90625 1.5C3.01436 3.53153 2.49665 3.92154 2.82967 4.82432C3.80188 7.45985 7.33588 7.38664 7.63147 10.1802C7.6846 10.6822 7.63147 11.473 7.63147 11.473",
    stroke: "#242E38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44755 22C5.97006 19.2297 4.67729 18.491 3.19982 16.6441C1.72234 14.7973 0.815336 12.6393 0.798918 9.81081C0.785002 7.41334 2.46107 4.82432 2.64575 3.9009C2.83043 2.97748 1.90701 1.5 1.90701 1.5",
    stroke: "#242E38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6133 22C9.50517 19.9685 10.0229 19.5785 9.68986 18.6757C8.71765 16.0402 5.18365 16.1134 4.88806 13.3198C4.83494 12.8178 4.88806 12.027 4.88806 12.027",
    stroke: "#242E38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07198 1.50001C6.54947 4.27028 7.84224 5.00902 9.31971 6.85587C10.7972 8.70271 11.7042 10.8607 11.7206 13.6892C11.7345 16.0867 10.0585 18.6757 9.87378 19.5991C9.6891 20.5225 10.6125 22 10.6125 22",
    stroke: "#242E38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscleBone);
export default __webpack_public_path__ + "static/media/muscle_bone.4cf3bc0c3405d2ffa58c094cddbcc823.svg";
export { ForwardRef as ReactComponent };